import {Component, OnInit, OnDestroy, AfterViewInit, ViewChild} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {AuthenticationService} from '../../_services/authentication.service';
import {AdminHeaderComponent} from './admin-header/admin-header.component'
import {AdminLeftSideComponent} from './admin-left-side/admin-left-side.component';
import {AppConfigs} from "../../app.config";
import {AlertsService} from 'angular-alert-module';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit, OnDestroy {

    bodyClasses = 'skin-blue sidebar-mini';
    body: HTMLBodyElement = document.getElementsByTagName('body')[0];
    user: any;
    messageInactive = '管理者がアカウントを無効にしました。 アカウントを有効にするには、もう一度管理者にご連絡ください！';
    @ViewChild(AdminHeaderComponent) adminHeader;
    @ViewChild(AdminLeftSideComponent) adminLeftSide;

    constructor(private router: Router, private authenticationService: AuthenticationService, private alerts: AlertsService) {
    }

    ngOnInit() {
        // add the the body classes
        this.body.classList.add('skin-blue');
        this.body.classList.add('sidebar-mini');
        this.checkLogin();
    }

    ngOnDestroy() {
        // remove the the body classes
        this.body.classList.remove('skin-blue');
        this.body.classList.remove('sidebar-mini');
    }

    checkLogin() {
        var currentUser = this.authenticationService.getCurrentUser();
        if (currentUser != null) {
            currentUser.subscribe(data => {
                if ((window.location.pathname.indexOf('/user') == 0 || window.location.pathname.indexOf('/admin/user') == 0) && !data.is_root_admin)
                    this.router.navigate(["/"]);
                else {
                    if (data.is_admin_approved == 0 && !data.is_root_admin) {
                        this.authenticationService.logout();
                        this.router.navigate(["/login"]);
                        this.alerts.setDefaults('timeout', 5);
                        this.alerts.setMessage(this.messageInactive, 'warn');
                        return false;
                    }
                    this.user = data;
                    this.adminHeader.displayName = this.user.name;
                    this.adminLeftSide.displayName = this.user.name;
                    this.adminLeftSide.isRootAdmin = this.user.is_root_admin;
                    let self = this;
                    this.asyncUser(this.user, () => {

                        let existUserConnect = self.authenticationService.getFieldUserCurrent('existUserConnect');
                        // redirect [profile-user] with USER not connected or unfriend line bot
                        if ((existUserConnect == false && !self.user.is_root_admin) || existUserConnect == null) {
                            self.router.navigate([AppConfigs.URL_USER_NOT_CONNECT]);
                        }
                    });
                }
            });
        }
        else {
            this.router.navigate(["/login"]);
        }
    }

    asyncUser(user, callback) {
        let self = this;
        self.adminLeftSide.avatarUser = self.adminHeader.avatarUser = self.authenticationService.getFieldUserCurrent('imgAvatar');

        // update status LocalStorage with key name
        self.authenticationService.asyncUserCurrent({'connectTwitter' : user.connectTwitter, 'existUserConnect':  user.existUserConnect});
        callback();
    }

}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_layouts/admin/admin.component.ts